export default __webpack_public_path__ + "static/media/dev-group.e00800c6.jpg";